import { combineReducers } from 'redux';
import imagens from './images'
import informacoes from './informacoes'
import vendas from './vendas'
import corretores from './corretores'
import paginas from './paginas'

export default combineReducers({
    imagens,
    informacoes,
    vendas,
    corretores,
    paginas,
});


// WEBPACK FOOTER //
// ./src/reducers/database.js